/**
 * useImmutableSelector.ts
 * ----------------
 * Hook for using selectors that use Immutable's "is" function for equality checks.
 */

import { is } from 'immutable';
import { useSelector } from 'react-redux';

/**
 * Hook for using a state selector that uses Immutable's "is" function. This allows consumers to avoid re-renders when
 * using complex data structures from Immutable.
 * @param selector Selector function.
 * @returns Selector hook using Immutable is.
 */
export function useImmutableSelector<TState, TValue> (selector: (state: TState) => TValue) {
    return useSelector<TState, TValue>(selector, is);
}
